import { render, staticRenderFns } from "./AmChart.vue?vue&type=template&id=37254282&scoped=true&"
import script from "./AmChart.vue?vue&type=script&lang=js&"
export * from "./AmChart.vue?vue&type=script&lang=js&"
import style0 from "./AmChart.vue?vue&type=style&index=0&id=37254282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37254282",
  null
  
)

export default component.exports